export default Object.freeze({
  ELEMENTARY: "294",
  JUNIOR_HIGH: "295",
  SENIOR_HIGH: "296",
  JUNIOR_COLLEGE: "297",
  UNIVERSITY: "298",
});
